<template>
  <CollectionDetail v-if="currentCollection" :collection="currentCollection" />
</template>
<script>
import CollectionDetail from '@/components/CollectionDetail.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Collection',
  components: {
    CollectionDetail
  },
  data () {
    return {
      collectionId: -1
    }
  },
  computed: {
    ...mapGetters({
      collection: 'productCatalog/collection'
    }),
    currentCollection () {
      let col = this.collection(this.collectionId)
      return col
    }
  },
  watch: {
    '$route.params.id': function () {
      this.loadCollectionInfo()
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadCollectionInfo()
  },
  methods: {
    ...mapActions({
      loadCollection: 'productCatalog/loadCollection'
    }),
    loadCollectionInfo () {
      this.collectionId = Number(this.$route.params.id)
      if (!this.currentCollection) {
        this.loadCollection(this.collectionId).then(response => {
          if (this.currentCollection === null) {
            this.$router.push({ name: '404' })
          }
        })
      }
    }
  }
}
</script>
